import React from 'react';
import logo from './logo.svg';
import AppRoutes from './Routes/AppRoutes';
import '../src/assets/style.css'
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import { RootState } from './Redux/store';

function App() {
    const { loading } = useSelector((state: RootState) => state.loading)
  return (
    <>
      <ToastContainer />
      <AppRoutes />
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}
    </>
    
  );
}

export default App;
